import { effects } from 'redux-saga'

import { updateZxcvbn } from '../../../modules/service/changePassword'

export default function* zxcvbnSaga(action) {
  if (action.payload.field !== 'first') {
    return
  }

  const result = yield effects.call(window.zxcvbn, action.payload.password)

  yield effects.put.resolve(updateZxcvbn(result))
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/service/changePassword/zxcvbn.js